import { graphql } from "~/gql";
import { useMutation, useQuery } from "@apollo/client";
import { OFFICE_LOCATIONS_QUERY, ORGANISATIONAL_UNITS_QUERY } from "~/graphql/query";

const UPDATE_PROPOSAL_HTML = graphql(/* GraphQL */ `
  mutation UpdateProposalHtml($update: UpdateProposalOutputInput!) {
    updateProposalHtml(update: $update)
  }
`);

export const PROPOSAL_BY_MATTER_ID = graphql(/* GraphQL */ `
  query ProposalByMatterId($matterId: Float!) {
    proposalByMatterId(matterId: $matterId) {
      html
      proposal {
        includeTasks
        includeRatesInProposalOutput
        includeFeeEarnersInProposalOutput
        feeRiskInclude
        feeRiskCappedFeeInclude
        feeRiskValid
        ganttAvailable
        ganttInclude
      }
      outputTemplateId
      outputTemplateName
      selectedOfficeId
      selectedOrganisationalUnitId
    }
  }
`);

export const UPDATE_PROPOSAL_OPTIONS = graphql(/* GraphQL */ `
  mutation UpdateProposalOptions($updateOptions: UpdateProposalOptionsInput!) {
    updateProposalOptions(updateOptions: $updateOptions) {
      includeTasks
      includeDiagram
      showFeeEarners
      showRates
    }
  }
`);

export type ProposalOptions = {
  includeTasks?: boolean;
  showFeeEarners?: boolean;
  showRates?: boolean;
  includeDiagram?: boolean;
};

export const useVpdProposalEngine = (matterId: number) => {
  const [updateProposalHtml] = useMutation(UPDATE_PROPOSAL_HTML);
  const { data: offices } = useQuery(OFFICE_LOCATIONS_QUERY, { fetchPolicy: "cache-first" });
  const { data: practiceAreas } = useQuery(ORGANISATIONAL_UNITS_QUERY, {
    fetchPolicy: "cache-first",
  });

  // Get the server parsed html.
  const {
    loading: isLoading,
    data: initialCompiledContent,
    refetch,
  } = useQuery(PROPOSAL_BY_MATTER_ID, {
    variables: { matterId },
    fetchPolicy: "network-only",
  });

  return {
    initialCompiledContent: initialCompiledContent?.proposalByMatterId,
    isLoading,
    updateProposalHtml,
    refetch,
    offices,
    practiceAreas,
  };
};
